/* eslint-disable functional/prefer-readonly-type */
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { Settings } from '@mui/icons-material'
import StandardModal from '../../../../components/StandardModal'
import { GridRowParams, MuiEvent } from '@mui/x-data-grid'
import { useLang } from '../../../../hooks/useLang'
import useEntryState from '../../stores/EntryState'
import { useHookstate, useState } from '@hookstate/core'
import { authFetch } from '~/services/fetch'
import LastCallList from '../LastCallsList'
import ScreenSettingsDraggableProps from '~/features/System/interfaces/ScreenSettings'
import useSystemState from '~/features/System/stores/SystemState'
import { storeScreenSettings } from '~/features/System/services'
import { Typography } from '@mui/material'

const modal = document.getElementById('div-modal') as HTMLElement

type EntryLogParams = {
  onRowClick?: (
    rows: GridRowParams,
    event: MuiEvent<React.MouseEvent<HTMLElement>>
  ) => boolean | undefined
}
interface TypePranks {
  total_prank_calls: number
  total_occurrences: number
  total_occurrences_last_hour: number
}

export default function EntryLogModalDraggable({ onRowClick }: EntryLogParams) {
  const { translate } = useLang()
  const { phone } = useState(useEntryState().entry())
  const countPrank = useHookstate<TypePranks>({
    total_prank_calls: 0,
    total_occurrences: 0,
    total_occurrences_last_hour: 0,
  })
  const { windowManager, loadingButton } = useSystemState()
  const totalRows = useHookstate(0)
  const getPositionsDraggable = useHookstate<ScreenSettingsDraggableProps>({
    id: 0,
    user_id: 0,
    url: '',
    window_name: '',
    x_position: 80,
    y_position: 141,
    is_window_open: true,
    is_window_minimized: false,
    created_at: new Date().toJSON(),
    updated_at: new Date().toJSON(),
    deleted_at: null,
  })

  useEffect(() => {
    authFetch({
      url: '/screen-setting/get-user-settings',
      method: 'POST',
      data: {
        url: location.pathname,
      },
    }).then((response) => {
      if ('EntryLogModalDraggable' in response.data) {
        getPositionsDraggable.set(response.data.EntryLogModalDraggable)
      }
    })

    return () => {
      windowManager()['EntryLogModal'].open.set(false)
    }
  }, [])

  const handleStop = (event, dragElement) => {
    event.stopPropagation()
    windowManager()['EntryLogModal'].merge({
      positionX: dragElement.x,
      positionY: dragElement.y,
    })
  }
  useEffect(() => {
    return () => {
      storeScreenSettings({
        windowName: 'EntryLogModalDraggable',
        isOpen: windowManager()['EntryLogModal'].open.get(),
        isMinimized: windowManager()['EntryLogModal'].minimized.get(),
        positionX: windowManager()['EntryLogModal'].positionX.get(),
        positionY: windowManager()['EntryLogModal'].positionY.get(),
      })
    }
  }, [
    windowManager()['EntryLogModal'].open.get(),
    windowManager()['EntryLogModal'].minimized.get(),
    windowManager()['EntryLogModal'].positionY.get(),
    windowManager()['EntryLogModal'].positionX.get(),
  ])

  if (windowManager()['EntryLogModal'].open.get()) {
    return ReactDOM.createPortal(
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {!loadingButton.get() && (
          <StandardModal
            title={translate('Last Calls')}
            subheader={
              <>
                <Typography variant="subtitle2">
                  {translate('Total calls')}
: 
{' '}
{totalRows.get()}
                </Typography>
                <Typography variant="subtitle2">
                  {translate('number_pranksN*')}
:
{' '}
                  {countPrank.get()?.total_prank_calls}
                </Typography>

                <Typography variant="subtitle2">
                  {translate('total_occurrences')}
:
{' '}
{countPrank.get()?.total_occurrences}
                </Typography>
                <Typography variant="subtitle2">
                  {translate('Total occurrences last hour')}
:
{' '}
{countPrank.get()?.total_occurrences_last_hour}
                </Typography>
              </>
            }
            dimensions={{
              width: 400,
            }}
            avatar={Settings}
            handleStop={handleStop}
            position={{
              x: windowManager()['EntryLogModal'].positionX.get()
                ? Number(windowManager()['EntryLogModal'].positionX.get())
                : 80,
              y: windowManager()['EntryLogModal'].positionY.get()
                ? Number(windowManager()['EntryLogModal'].positionY.get())
                : 141,
            }}
            closeButton={() => windowManager()['EntryLogModal'].open.set(false)}
            isExpanded={windowManager()['EntryLogModal'].minimized}
          >
            <LastCallList
              phone={phone.get()}
              totalRows={totalRows}
              countPrank={countPrank}
            />
          </StandardModal>
        )}
      </>,
      modal
    )
  } else {
    return <></>
  }
}
